const OnlinePurchase = () => {
	return (
		<>
			<section className="contact py-80">
				<div className="container container-lg">
					<div className="row gy-5">
						<div className="col-lg-6">
							<div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
								<h4 className="text-bold headingsize ">
									Understanding Online{" "}
									<span className="primecolor">Purchase</span>
								</h4>
								<h6 className="title text-lg fw-semibold  mb-8 mt-10 primecolor">
									(Also Known as E-commerce)
								</h6>
								<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-10">
									Online purchase refers to shopping directly through any
									electronic media over the internet using platforms such as
									websites or apps. It enables:
								</h6>

								<ul className="mt-20">
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											<span className="text-gray-500">
												<span className="text-gray-500 px-1">
													Shopping based on personal choices
												</span>{" "}
											</span>
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											<span className="text-gray-500">
												<span className="text-gray-500 px-1">
													Access to a global market at your fingertips
												</span>{" "}
											</span>
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											<span className="text-gray-500">
												<span className="text-gray-500 px-1">
													Shopping using devices like desktops, laptops,
													mobiles, and tablets
												</span>{" "}
											</span>
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-heading fw-medium">
											<span className="text-gray-500">
												<span className="text-gray-500 px-1">
													In online purchases, the platform itself acts as the
													seller from where the customer buys the product.
												</span>{" "}
											</span>
										</span>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-6 d-flex justify-content-center">
							<div className="">
								<img loading="lazy"
									src="assets/images/about/online-purchase-img.png"
									alt=""
									className="cover-img rounded-16 about"
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="container container-lg pt-60">
					<div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
						<div className="row gy-5">
							<div className="col-lg-6 px-20">
								<h6 className="mb-24">How to Make an Online Purchase</h6>
								<h6 className="title text-lg fw-semibold mt-12 mb-8">
									Just like we go to a store and tell the salesman what we want,
									in online shopping:
								</h6>
								<ul className="mt-20">
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											We use keywords to describe what we want to buy by typing
											them in the search bar.
										</span>
									</li>

									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											The shopping platform then displays the best matching
											options based on the keywords.
										</span>
									</li>

									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											We can view product details, compare options, and explore
											the marketplace.
										</span>
									</li>

									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											Keyword search is a powerful tool in helping us find
											exactly what we need.
										</span>
									</li>
								</ul>
								<div>
									<div>
										<h6 className="mb-24 title text-lg fw-semibold  mt-24 ">
											Once we find a <span className="primecolor">product</span>{" "}
											:
										</h6>

										<ul className="mt-20">
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													We add it to the cart or basket.
													<span className="text-gray-500">
														<span className="text-gray-500 px-1"></span>{" "}
													</span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Continue shopping if needed.
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													After finishing, proceed to checkout.
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>

											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Provide the delivery location and select a payment
													method.
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Complete the purchase.
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
										</ul>
									</div>
									<div>
										<h6 className="mb-10">
											About <span className="primecolor">udemandme.com</span>{" "}
										</h6>
										<p>
											Visit : <a href="https://udemandme.com/">udemandme.com</a>{" "}
											is one of the upcoming online portals that aims to fulfill
											your demands quickly, with a focus on quality and timely
											delivery.
										</p>
										<h6 className="mb-10 title text-lg fw-semibold  mt-10 ">
											Customer Communication
										</h6>
										<ul className="mt-10">
											<li className="text-gray-400 mb-14 flex-align gap-14">
												<span className="text-md text-gray-900 ">
													Contact via contact forms, email, and WhatsApp.
												</span>
											</li>

											<li className="text-gray-400 mb-14 flex-align gap-14">
												<span className="text-md text-gray-900 ">
													You can also send bulk inquiries via WhatsApp, and the
													team will respond promptly.
												</span>
											</li>
										</ul>
										<h6 className="mb-10 title text-lg fw-semibold  mt-10 ">
											Search Functionality
										</h6>
										<ul className="mt-10">
											<li className="text-gray-400 mb-14 flex-align gap-14">
												<span className="text-md text-gray-900 ">
													Use keywords to search for items in the search bar.
												</span>
											</li>

											<li className="text-gray-400 mb-14 flex-align gap-14">
												<span className="text-md text-gray-900 ">
													You can also send bulk inquiries via WhatsApp, and the
													team will respond promptly.You can add items directly
													to your cart from the search results to save time.
												</span>
											</li>
											<li className="text-gray-400 mb-14 flex-align gap-14">
												<span className="text-md text-gray-900 ">
													If you can't find a product, just take a photo and
													send it via WhatsApp—the team will assist you as soon
													as possible.
												</span>
											</li>
										</ul>
										<h6 className="mb-10 title text-lg fw-semibold  mt-10 ">
											Product Information
										</h6>
										<ul className="mt-10">
											<li className="text-gray-400 mb-14 flex-align gap-14">
												<span className="text-md text-gray-900 ">
													Instead of scrolling endlessly, just click on the
													“Information” tab (if available) to see detailed
													product info.
												</span>
											</li>
											<li className="text-gray-400 mb-14 flex-align gap-14">
												<span className="text-md text-gray-900 ">
													This saves your time and helps you make quicker and
													more informed purchase decisions.The layout is
													user-friendly and avoids unnecessary navigation. You
													get all the important specifications in one place.
													It’s a simple and efficient way to understand the
													product before buying.
												</span>
											</li>
											<li className="text-gray-400 mb-14 flex-align gap-14">
												<span className="text-md text-gray-900 ">
													You can also download this information directly for
													your reference.
												</span>
											</li>
										</ul>
									</div>
								</div>
							</div>

							<div className="col-lg-6 px-20">
								<div>
									<h6 className="mb-24 ">Credit System</h6>
									<h6 className="mb-10 title text-lg fw-semibold  mt-10 ">
										Just like traditional businesses offer credit based on
										documentation:
									</h6>

									<ul className="mt-20">
										<ul className="mt-10">
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-heading fw-medium">
													<span className="text-gray-500">
														<span className="text-gray-500 px-1">
															udemandme.com offers a credit limit and credit
															period based on approved documentation.
														</span>{" "}
													</span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-heading fw-medium">
													<span className="text-gray-500 px-1">
														After placing an order on credit:
													</span>
												</span>
											</li>

											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													You must send a cheque copy within 12 working hours.
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													At the time of delivery, you must provide the original
													cheque.
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>

											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-heading fw-medium">
													<span className="text-gray-500 px-1">
														This system allows you to do business online while
														maintaining standard business protocols.
													</span>
												</span>
											</li>
										</ul>
									</ul>
									<h6 className="mb-24 ">Payment Modes</h6>
									<h6 className="mb-10 title text-lg fw-semibold  mt-10 ">
										Payment is made easy and flexible through multiple options:
									</h6>
									<ul className="mt-10">
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												Cash
												<span className="text-gray-500">
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												Credit Card
												<span className="text-gray-500">
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												Debit Card
												<span className="text-gray-500">
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												Net Banking
												<span className="text-gray-500">
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												Cheque (for approved customers)
												<span className="text-gray-500">
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												Wallet
												<span className="text-gray-500">
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
									</ul>
									<h6 className="mb-24 ">Wallet Cashback</h6>

									<ul className="mt-10">
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												On every purchase, you get 0.5% cashback in your wallet
												after the return period ends.
												<span className="text-gray-500">
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												You can use this cashback in your next purchase.
												<span className="text-gray-500">
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
									</ul>
									<h6 className="mb-24 ">Additional Discounts</h6>

									<ul className="mt-10">
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												<span className="text-gray-500">
													If you transfer money directly from your bank account
													using online banking (without availing any credit
													period), you get an additional 0.5% discount on your
													total bill.
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												<span className="text-gray-500">
													If you pay in cash or by swiping your credit card upon
													delivery, you also receive an instant 0.5% cash
													discount.
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
									</ul>

									<div>
										<h6 className="mb-5 primecolor mt-24">Conclusion</h6>

										<ul className="mt-20">
											<li className="text-gray-400 mb-14 flex-align gap-14">
												<span className="text-md text-gray-900 ">
													There are numerous benefits to using udemandme.com. It
													offers a blend of online convenience and traditional
													business practices. Try it out and explore even more
													features tailored to meet your needs!
												</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
export default OnlinePurchase;
